/* Bad Earl — first-visit intro overlay.
   Plays one clip over the whole site, fades through black, then hands the page
   back. Every failure path reveals the site rather than trapping the visitor. */
(function () {
  var html = document.documentElement;
  var root = document.querySelector('[data-be-intro]');
  if (!root) return;

  function drop() {
    if (root.parentNode) root.parentNode.removeChild(root);
    html.classList.remove('be-intro-active', 'be-intro-lock');
    document.body.classList.remove('overflow-hidden');
  }

  // The snippet's inline script decides whether this visit gets the intro.
  if (!html.classList.contains('be-intro-active')) {
    drop();
    return;
  }

  var video = root.querySelector('[data-be-intro-video]');
  var skip = root.querySelector('[data-be-intro-skip]');
  var mode = root.getAttribute('data-frequency') || 'session';
  var fadeMs = (parseFloat(root.getAttribute('data-fade')) || 1) * 1000;
  var maxMs = (parseFloat(root.getAttribute('data-max-seconds')) || 12) * 1000;
  var finished = false;
  var guard;

  // Dawn's lock class, which also tells be-motion.js to pause Lenis.
  document.body.classList.add('overflow-hidden');

  function remember() {
    if (mode === 'always') return;
    try {
      var store = mode === 'once' ? window.localStorage : window.sessionStorage;
      if (store) store.setItem('be-intro-seen', '1');
    } catch (e) {
      /* private mode — just play it again next time */
    }
  }

  function reveal() {
    if (finished) return;
    finished = true;
    clearTimeout(guard);
    remember();

    // Clip to black, hold on black, then black to site.
    root.classList.add('is-fading');

    setTimeout(function () {
      root.classList.add('is-done');
      html.classList.remove('be-intro-lock');
      document.body.classList.remove('overflow-hidden');

      if (video) {
        try {
          video.pause();
        } catch (e) {
          /* no-op */
        }
      }

      if (window.beLenis && typeof window.beLenis.start === 'function') {
        window.beLenis.start();
      }

      window.dispatchEvent(new CustomEvent('be:intro-done'));

      // Keep the node until its fade-out finishes.
      setTimeout(drop, fadeMs + 120);
    }, fadeMs + 220);
  }

  if (skip) {
    skip.addEventListener('click', reveal);
    try {
      skip.focus({ preventScroll: true });
    } catch (e) {
      skip.focus();
    }
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') reveal();
  });

  var src = video && video.getAttribute('data-src');
  if (!src) {
    reveal();
    return;
  }

  video.addEventListener('ended', reveal);
  video.addEventListener('error', reveal);

  // Once the real length is known, hold only as long as the clip needs.
  video.addEventListener('loadedmetadata', function () {
    if (!isFinite(video.duration) || video.duration <= 0) return;
    clearTimeout(guard);
    guard = setTimeout(reveal, video.duration * 1000 + fadeMs + 1500);
  });

  // Safari needs the property, not just the attribute, to allow autoplay.
  video.muted = true;
  video.src = src;

  var attempt = video.play();
  if (attempt && typeof attempt.catch === 'function') {
    // Muted autoplay is normally allowed; honour a refusal instead of showing
    // a frozen frame.
    attempt.catch(reveal);
  }

  guard = setTimeout(reveal, maxMs);
})();
